module.exports = __webpack_public_path__ + "img/26_storm.828edcfb.jpg";